import { Vue, Component,Watch } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { gettHeaderByType, settHeaderByType } from '@/api/common'
import { getFinanceBackMoneyList, setFinanceBackMoneyStatus, financeBackMoneyExportData, delFinanceBackMoneyById } from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'

import { delNullProperty } from '@/utils/index'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import CreateBackMoneyReceipt from "@/components/createBackMoneyReceipt/index.vue";

@Component({
    components:{
        MoreUsersFilter, CreateBackMoneyReceipt
    }
})
export default class BackMoney extends Vue {
    tableData = []
    tableHeader = []
    tableHeadPopoverShow = false
    tableLoading = false
    // tableKey = Math.random()

    filter_mainPart = ''
    filter_customerOrCooperationName = ''
    surplusBackMoney = '' //待回款金额
    surplusBackMoneyrange = '' //待回款金额范围
    surplusBackMoneyNum = '' //待回款金额
    filter_createdAt: Date[] = []
    filter_status = ''
    filter_code = ''
    total = 0
    page = 1
    limit = 20

    dialogVisible = false
    newType = '' // ’1‘ 学生 '2' 合作伙伴

    delBackMoneyId: number = null
    delBackMoneyDialogShow = false
    cancelApproveDialog = false
    reviewId = NaN
    action = ''
    exportButtonDisabled = false
    tableKey = Math.random()
    filter_userIdList: string[] = []
    filter_backMoneyAt: Date[] = []
    timer = null
    draggableList = []
    draggableListChange = []
    receiptData = {
        receiptNo: '',
        receiptYear: '',
        receiptMonth: '',
        receiptDay: '',
        receiptMainPart: '',
        receiptImg: '',
        receiptPrice: '',
    } // 开收据需要的数据
    receiptDialogVisible = false

    get createdAt() {
        let str = ''
        if (this.filter_createdAt && this.filter_createdAt.length > 0) {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_createdAt[1]))
        }
        return str
    }


    get timeBegin() {
        let str = ''
        if(!this.filter_backMoneyAt || this.filter_backMoneyAt.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_backMoneyAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.filter_backMoneyAt[1]))
        }
        return str
    }

    get arrsurplusBackMoneyrange(){
        const surplusBackMoneyrange = this.surplusBackMoneyrange
        const surplusBackMoneyNum = this.surplusBackMoneyNum
        return {
            surplusBackMoneyrange,surplusBackMoneyNum
        }
    }

    created() {
        this.gettHeaderByType()
    }

    menuBtn = menuBtn
    async gettHeaderByType() {
        const data: any = await gettHeaderByType(9)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    async getTableData() {
        this.tableLoading = true

        const obj = {
            mainPart: this.filter_mainPart,
            customerOrCooperationName: this.filter_customerOrCooperationName,
            surplusBackMoney: this.surplusBackMoneyrange + this.surplusBackMoneyNum, //待回款金额
            directorUserIdList: this.filter_userIdList, // 负责人
            backMoneyAt: this.timeBegin, // 回款日期
            createdAt: this.createdAt,
            status: this.filter_status,
            code: this.filter_code,
            limit: this.limit,
            page: this.page,
        }
        const data: any = await getFinanceBackMoneyList(delNullProperty(obj))
        this.tableData = data.financeBackMoneyList
        this.total = data.allNum
        this.tableLoading = false

        this.tableKey = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
    }

    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = {
            mainPart: this.filter_mainPart,
            customerOrCooperationName: this.filter_customerOrCooperationName,
            surplusBackMoney: this.surplusBackMoneyrange + this.surplusBackMoneyNum, //待回款金额
            directorUserIdList: this.filter_userIdList, // 负责人
            backMoneyAt: this.timeBegin, // 回款日期
            createdAt: this.createdAt,
            status: this.filter_status,
            code: this.filter_code,
        }
        financeBackMoneyExportData(delNullProperty(obj)).finally(() => {
            this.exportButtonDisabled = false
        })
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    // 改变表头
    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 9})
            this.tableHeadPopoverShow = false
            this.$message.success('修改表头成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
        // this.gettHeaderByType()
    }

    clickNewBackMoneyButton() {
        let url = ''
        if (this.newType === '1') {
            url = this.$route.matched[0].path + '/newBackMoneyStudent'
            this.openPage(url)
            this.newType = ''
        } else if(this.newType === '2') {
            url = this.$route.matched[0].path + '/newBackMoneyMechanism'
            this.openPage(url)
            this.newType = ''
        }else{
            this.$message.info('请选择回款主体')
        }

    }

    clickTableRow(row, col) {
        if (!this.menuBtn(64)) return
        const arr = ['操作']
        if (arr.includes(col.label)) return
        let url = window.location.origin + this.$route.matched[0].path
        if (row.mainPart === '合作伙伴') {
            url += `/backMoneyParnterInfo?id=${row.id}&status=${row.status}&isUpdatedData=0`
        }
        if (row.mainPart === '学生') {
            url += `/backMoneyStudentInfo?id=${row.id}&status=${row.status}&isUpdatedData=0`
        }
        this.openPage(url)
    }

    clickEditButton(row) {
        let url = window.location.origin + this.$route.matched[0].path
        if (row.mainPart === '学生') url += '/newBackMoneyStudent?backMoneyId=' + row.id + '&status=' + row.status + '&isUpdatedData=0'+ '&isShow=' + row.isShow
        if (row.mainPart === '合作伙伴') url += '/newBackMoneyMechanism?backMoneyId=' + row.id + '&status=' + row.status + '&isUpdatedData=0'+ '&isShow=' + row.isShow
        this.openPage(url)
    }

    // 提交/撤回审批
    clickCancelApproveDialogConfirmButton(row) {
        if (this.action === '0') {
            let url = window.location.origin + this.$route.matched[0].path
            // isUpdatedData--要查看的数据类型 // '0'-原始数据, '1'-更新后的数据
            if (row.mainPart === '学生') url += '/newBackMoneyStudent?backMoneyId=' + row.id + '&status=' + row.status + '&isUpdatedData=1'
            if (row.mainPart === '合作伙伴') url += '/newBackMoneyMechanism?backMoneyId=' + row.id + '&status=' + row.status + '&isUpdatedData=1'
            this.openPage(url)
        } else {
            setFinanceBackMoneyStatus({
                id: this.reviewId,
                action: this.action
            }).then(() => {
                this.$message.success(`成功${this.action === '0' ? '提交' : '撤回'}审批`)
                this.getTableData()
                this.cancelApproveDialog = false
            }).catch((err: Error) => {
                // 没有查到相关审批流程，暂时无法新建订单，请联系管理员设置审批流程
                if (err.message === '审批流报错') {
                    this.$message.error('此审批流程不适用您，请联系管理员')
                }
            })
        }
    }

    async setFinanceBackMoneyStatus(row: any, action: string) {
        this.reviewId = row.id
        this.action = action
        if (action === '0') {
            this.clickCancelApproveDialogConfirmButton(row)
        } else {
            this.cancelApproveDialog = true
        }
    }

    openPage(url: string) {
        const win = window.open(url, '_blank')
        this.dialogVisible = false
        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }

    delBackMoney(id) {
        this.delBackMoneyId = id
        this.delBackMoneyDialogShow = true
    }

    async delBackMoneyDialogConfirm() {
        await delFinanceBackMoneyById(this.delBackMoneyId)
        this.$message.success('删除成功')
        this.delBackMoneyDialogShow = false
        this.getTableData()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData();
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    // 跳转统计图表页面
    goToDtatisticsData() {
        const { origin } = window.location
        const src = origin + '/financialCenter/collectionReport'
        window.open(src, '_blank')
    }

    changeUserList(e) {
        this.filter_userIdList = e.id
        this.page = 1
        this.getTableData()
    }

    // 下载收据
    downloadReceipt(row) {

        this.receiptDialogVisible = true;

        this.receiptData.receiptMainPart = row.customerOrCooperationName
        this.receiptData.receiptNo = row.code
        this.receiptData.receiptPrice = row.backMoney
        this.receiptData.receiptYear = row.backMoneyAt.split('-')[0]
        this.receiptData.receiptMonth = row.backMoneyAt.split('-')[1]
        this.receiptData.receiptDay = row.backMoneyAt.split('-')[2];
        this.receiptData.receiptImg = row.financeUrlStr;

        // 都不为空的情况才能下载回款凭证
        const obj = this.receiptData
        let flag = true
        for (const key in obj) {
            if (!obj[key] || obj[key].length === 0) {
                // 提示--无法生成 请联系财务部门
                this.$message.error('无法生成 请联系财务部门')
                flag = false
                return
            }
        }
        if (flag) {
            setTimeout(() => {
                (this.$refs.downloadReceipt as any).generateImage()
            }, 1000)
        }
    }

    handleClose() {
        this.receiptDialogVisible = false
    }

    @Watch('arrsurplusBackMoneyrange')
    handleBackmoney(nVal,oVal){
        if((nVal.surplusBackMoneyrange && nVal.surplusBackMoneyNum)||(!nVal.surplusBackMoneyrange && !nVal.surplusBackMoneyNum)){
            this.pageChange(1)
        }
    }
}
